import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=49cd7bdc&lang=pug&"
import script from "./Heart.vue?vue&type=script&lang=ts&"
export * from "./Heart.vue?vue&type=script&lang=ts&"
import style0 from "./Heart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cd7bdc')) {
      api.createRecord('49cd7bdc', component.options)
    } else {
      api.reload('49cd7bdc', component.options)
    }
    module.hot.accept("./Heart.vue?vue&type=template&id=49cd7bdc&lang=pug&", function () {
      api.rerender('49cd7bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/icons/Heart.vue"
export default component.exports